import { postData } from "../util";
import Swal from "sweetalert2";

document.addEventListener("DOMContentLoaded", () => {
  const forgotPasswordForm = document.getElementById("forgot-password-form");
  forgotPasswordForm?.addEventListener("submit", async (e) => {
    e.preventDefault();

    const email = document.getElementById("email").value;

    try {
      const res = await postData("/api/company/forgot-password", { email });

      if (res && res.body.success) {
        await Swal.fire("Επιτυχία!", res.body.msg, "success");
        window.location.href = "/company/signin";
      } else {
        Swal.fire("Error", res.body.error || "An error occurred.", "error");
      }
    } catch (error) {
      console.error("Forgot Password Error:", error);
      Swal.fire("Error", "An unexpected error occurred.", "error");
    }
  });
});
